<template>
    <div id="footer">
        <div id="copyright" class="text-center my-4 container-xxl">
            {{ currentYear }}, © {{ $t('app.develop_with') }}&nbsp;&nbsp;<font-awesome-icon :icon="['fas', 'heart']" beat :style="{ color: 'var(--bs-danger)' }" />&nbsp;&nbsp;{{ $t('app.by') }} <a class="text-decoration-none" href="http://en.samo.ru" target="_blank">SAMO-Soft</a>
        </div>

        <div class="footer-container">
            <div class="container-xxl py-4">
                <div class="row">
                    <div class="col-md">
                        <img src="@/assets/images/logo.png" id="footer-logo" class="mb-2" />
                        <div>{{ $t('app.footer_text') }}</div>
                    </div>
                    <div class="col-md">
                        <subscribe-form />
                    </div>
                    <div class="col-md">
                        <ul class="nav flex-column pt-4">
                            <template v-for="(item, index) in footerNav"
                                     :key="index">
                                <router-link v-if="['login', 'logout', 'myClaim'].indexOf(item) === -1"
                                    :to="{ 
                                        name: item,
                                        query: {
                                            search: item == 'wizard' ? 1 : null,
                                        }
                                    }"
                                    custom
                                    v-slot="{ href, navigate, isActive }"
                                >
                                    <li>
                                        <a :class="{ active: isActive }"
                                            :href="href"
                                            @click="navigate"
                                            class="nav-link text-white">
                                                <template v-if="item !== 'wizard'">{{ $t('nav.' + (['aboutRu', 'aboutEn'].indexOf(item) !== -1 ? 'about' : item)) }}</template>
                                                <template v-else>{{ $t('nav.hotels') }}</template>
                                        </a>
                                    </li>
                                </router-link>
                                <li v-else-if="item === 'myClaim'">
                                    <a @click="this.$refs.goToClaimModal.open();"
                                        class="nav-link text-white">
                                            {{ $t('app.' + item) }}
                                    </a>
                                </li>
                                <li v-else>
                                    <a @click="nav(item)"
                                        class="nav-link text-white">
                                            {{ $t('app.' + item) }}
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div class="col-md footer-contacts" v-if="email || phone">
                        <h4 class="fw-normal mb-2">{{ $t('app.footer_contacts_title') }}</h4>
                        <a class="fs-5 nav-link text-white" :href="'tel:'+ phoneLink">{{ phone }}</a>
                        <a class="fs-5 nav-link text-white" :href="'mailto:' + email">{{ email }}</a>
                        <div>{{ $t('app.footer_contacts_text') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <go-to-claim-modal ref="goToClaimModal" />

</template>

<script>
import SubscribeForm from '@/modules/subscribe/SubscribeForm.vue'
import GoToClaimModal from '@/modules/login/GoToClaimModal.vue'
import { mapState } from 'vuex'

export default {
    name: 'AppFooter',
    data() {
        return {
            
        }
    },
    components: {
        SubscribeForm, GoToClaimModal
    },
    computed: {
        ...mapState({
            locale: state => state.locale,
            config: state => state.config
        }),
        currentYear() {
            return new Date().getFullYear();
        },
        footerNav() {
            const nav = ['wizard'];
            const aboutPage = this.locale == 'ru' ? 'aboutRu' : 'aboutEn';
            nav.unshift(aboutPage);
            const authAction = this.$store.getters['users/isAuth'] ? 'logout' : 'login';
            nav.push(authAction);
            nav.push('myClaim');

            return nav;
        },
        email(){
            return this.config?.main?.contacts?.email;
        },
        phone(){
            return this.config?.main?.contacts?.phone;
        },
        phoneLink(){
            return this.config?.main?.contacts?.phone_link;
        }
    },
    methods: {
        nav(action){
            if(action === 'login')
                this.$parent.$refs.header.$refs.loginModal.openLoginModal();
            else
                this.$store.dispatch('users/logout', this.$router);
        }
    }
}
</script>

<style scoped>
a.nav-link{
    cursor: pointer;
}
.footer-container{
    color: #ccc;
    background-color: #333;
    font-size: .85rem;
    font-weight: 400;
}
#footer-logo{
    height: 50px;
}
.footer-container .nav-link:not(.fs-5){
    font-size: .85rem !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.footer-container .nav-link:hover{
    text-decoration: underline;
}
@media (max-width: 768px) {
    .footer-container{
        text-align: center;
    }
    .footer-contacts{
        margin-top: 1rem;
    }

}
</style>
